import { useOutletContext } from "react-router-dom";

import WorkOverviewView from "../views/WorkOverviewView/WorkOverviewView";

export default function WorkOverview() {
	const context = useOutletContext();

	return <WorkOverviewView {...context} />;
}
